export default {
  order_methods: {
    delivery: 'Livraison',
    pickup: 'Retrait',
    room_service: 'Sur place',
    table_service: 'Sur place',
  },
  time: '{{time}} min',
  asap: 'ASAP',
  unavailable: 'Indisponible',
  ready_in: 'Prêt dans ',
  buttons: {
    change: 'Modifier',
    see_hours: 'Voir les horaires',
    change_location: 'Changer de lieu',
    change_time: "Changer l'heure",
  },
};
